import { useRouter } from 'next/router';

import { Heading, Text } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../hooks/queries/properties';
import propertyUtils from '../../../../utils/propertyUtils';

import RMWInput from '../../../RMWInput';

import type { ConvertableItemType } from '../types';

type UnitNumberProps = {
  selectedItem: ConvertableItemType;
  submitErrorMessage?: string;
  handleUnitNumberBlur: (unitNumber: string) => void;
};

const UnitNumber = ({ selectedItem, submitErrorMessage = '', handleUnitNumberBlur }: UnitNumberProps) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const { formattedCompleteAddress } = propertyUtils.formatAddress({
    street: listingDetails?.street ?? '',
    city: listingDetails?.city ?? '',
    state: listingDetails?.state ?? '',
    zip: listingDetails?.zip ?? '',
    unit: listingDetails?.unit ?? '',
    name: listingDetails?.name ?? '',
  });

  return (
    <>
      <Heading level={4} css={{ marginBottom: '400' }}>
        Unit address
      </Heading>
      <Text asChild css={{ marginBottom: '400' }}>
        <p>{`Please confirm the unit number for ${formattedCompleteAddress}.`}</p>
      </Text>
      <RMWInput
        disabled={!selectedItem.id}
        initialValue={selectedItem.unitName}
        errorMessage={submitErrorMessage}
        label="Unit number"
        placeholder="(Optional)"
        onBlur={(value) => {
          if (typeof value === 'string') {
            handleUnitNumberBlur(value);
          }
        }}
        leftAdornment="#"
        inputType="adorned"
        maxLength="20"
      />
    </>
  );
};

export default UnitNumber;
